import { useTranslation } from "react-i18next";
import { CalendarClock } from "lucide-react";
import { DetailCard } from "./DetailCard";
import { fmtPct } from "../../../lib/format";

const Row = ({ index, item, t }) => (
  <div className="grid grid-cols-3 items-center gap-2 rounded-xl bg-primary/5 px-3 py-2 text-xs"
       data-testid={`row-installment-${index + 1}`}>
    <span className="font-bold text-primary">
      {t("purchases.podetail.installment")} {index + 1}
    </span>
    <span className="num text-center font-mono font-bold">
      {fmtPct(item.percent || item.percentage || 0)}%
    </span>
    <span className="text-end text-muted-foreground">
      {t(`purchases.podetail.installmentTypes.${item.kind || item.type || "advance"}`,
         item.label || item.kind || "—")}
    </span>
  </div>
);

// تفاصيل شروط الدفع: النوع وقائمة الأقساط إن وجدت.
export const DetailPayment = ({ doc }) => {
  const { t } = useTranslation();
  const list = doc.payment_installments || [];
  const kind = doc.payment_terms_kind || (doc.payment_terms_days === 0 ? "cash" : null);
  return (
    <DetailCard tid="section-payment" icon={CalendarClock}
                title={t("purchases.podetail.paymentDetails")}>
      {list.length ? (
        <div className="grid gap-1.5">
          {list.map((item, i) => <Row key={i} index={i} item={item} t={t} />)}
        </div>
      ) : (
        <p className="text-xs text-muted-foreground" data-testid="row-payment-kind">
          {kind ? t(`purchases.paymentKinds.${kind}`, kind) : "—"}
        </p>
      )}
    </DetailCard>
  );
};
